export default __webpack_public_path__ + "ad30169.png";